import { RegionalRiskEmptyScreenIcon } from '@protector/icons';
import { COLOR_OPTIONS } from 'config/style';
import STTypo from 'core/shared/typo';
import { TypeOptions } from 'core/shared/typo/typo.models';
import { useTranslation } from 'react-i18next';

import './regional-overview-empty-screen.less';

const RegionalOverviewEmptyScreen = (): JSX.Element => {
  const [t] = useTranslation();
  return (
    <div data-testid='regional-overview-mycotoxin-empty-screen-container' className='regional-overview-mycotoxin-empty-screen__container'>
      <RegionalRiskEmptyScreenIcon />
      <div className='regional-overview-mycotoxin-empty-screen__wrapper-info'>
        <STTypo
          data-testid='regional-overview-mycotoxin-empty-screen-title'
          fontWeight={500}
          type={TypeOptions.H3}
          color={COLOR_OPTIONS.WHITE}>
          {t('pages.regional_overview.regional_mycotoxin.empty_screen.title')}
        </STTypo>
        <STTypo type={TypeOptions.P1} color={COLOR_OPTIONS.WHITE} data-testid='regional-overview-mycotoxin-empty-screen-description'>
          {t('pages.regional_overview.regional_mycotoxin.empty_screen.description')}
        </STTypo>
      </div>
    </div>
  );
};

export default RegionalOverviewEmptyScreen;
